// removed by extract-text-webpack-plugin
module.exports = {"resume-header":"_1_phxsBu","resumeHeader":"_1_phxsBu","name":"_1tBTeVmZ","title":"RHY2dM2H","contact":"_1MgdnNsB","link":"_1ywBFfbu"};


//////////////////
// WEBPACK FOOTER
// ./src/views/ResumeView/ResumeHeader/ResumeHeader.pcss
// module id = 1009
// module chunks = 0